import { Link } from "react-router-dom";
import type { ReactNode } from "react";

export default function PageHero({
  eyebrow,
  title,
  description,
  crumbs,
}: {
  eyebrow: string;
  title: string;
  description: string;
  crumbs?: ReactNode;
}) {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="paper-grid w-full">
        <div className="w-full px-4 py-10 md:px-6 md:py-14 lg:px-10">
          {crumbs && <div className="mb-5">{crumbs}</div>}
          <p className="text-xs font-medium tracking-[0.25em] text-primary-700">
            {eyebrow}
          </p>
          <h1 className="mt-3 max-w-3xl font-heading text-2xl font-bold leading-snug tracking-tight text-foreground-950 md:text-4xl">
            {title}
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
}

export function SectionHeading({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: { label: string; to: string };
}) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between md:mb-8">
      <div>
        <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            {description}
          </p>
        )}
      </div>
      {action && (
        <Link
          to={action.to}
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-600"
        >
          {action.label}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-base"></i>
          </span>
        </Link>
      )}
    </div>
  );
}